module.exports = __webpack_public_path__ + "static/media/stationary2.58efc29f.jpg";